import {
  TypographySize,
  ScreenSize,
  FontSizeMap,
  SCREEN_SIZE,
} from 'mm-theme-configuration/dist/consts';

const lineHeightRatioMap = {
  gigantic: {
    large: 1.4,
    medium: 1.375,
    small: 1.333,
  },
  huge: {
    large: 1.375,
    medium: 1.333,
    small: 1.4,
  },
  large: {
    large: 1.4,
    medium: 1.4,
    small: 1.5,
  },
  bigger: {
    large: 1.5,
    medium: 1.5,
    small: 1.43,
  },
  big: {
    large: 1.43,
    medium: 1.43,
    small: 1.333,
  },
  normal: {
    large: 1.5,
    medium: 1.5,
    small: 1.43,
  },
};

type TypographySizeStyleByScreenSize = {
  breakpoints: {
    [key in ScreenSize]: {
      fontSize: string;
      lineHeight: string;
    }
  };
}

type TypographySizeStyleCrossScreenSizes = {
  style: {
    fontWeight: number;
    fontFamily: string;
  };
}

export type TranslatedFontSize = {
  [key in TypographySize]: TypographySizeStyleByScreenSize & TypographySizeStyleCrossScreenSizes
};

export type TypographySizesFontFamiliesMap = {
  [key in TypographySize]: {
    fontFamily: string;
    defaultFontFamily: string;
  }
}

export type ActualTypographySizesFontFamiliesMap = {
  [key in TypographySize]: string
}

const getFontSize = (size: number) => `${size}px`;
const getLineHeightByFontSize = (fontSize: number, size: TypographySize, screenSize: ScreenSize) => `${fontSize * lineHeightRatioMap[size][screenSize]}px`;

export const translateFontSizes = (fontSizeMap: FontSizeMap, actualTypographySizesFontFamiliesMap: ActualTypographySizesFontFamiliesMap) => {
  return (Object.keys(fontSizeMap) as TypographySize[]).reduce((sizesObj: TranslatedFontSize, current: TypographySize) => {
    return {
      ...sizesObj,
      [current]: {
        breakpoints: {
          [SCREEN_SIZE.LARGE]: {
            fontSize: getFontSize(fontSizeMap[current].screenSizes.large),
            lineHeight: getLineHeightByFontSize(fontSizeMap[current].screenSizes.large, current, SCREEN_SIZE.LARGE as ScreenSize),
          },
          [SCREEN_SIZE.MEDIUM]: {
            fontSize: getFontSize(fontSizeMap[current].screenSizes.medium),
            lineHeight: getLineHeightByFontSize(fontSizeMap[current].screenSizes.medium, current, SCREEN_SIZE.MEDIUM as ScreenSize),
          },
          [SCREEN_SIZE.SMALL]: {
            fontSize: getFontSize(fontSizeMap[current].screenSizes.small),
            lineHeight: getLineHeightByFontSize(fontSizeMap[current].screenSizes.small, current, SCREEN_SIZE.SMALL as ScreenSize),
          },
        },
        style: {
          fontWeight: fontSizeMap[current].fontWeight,
          fontFamily: actualTypographySizesFontFamiliesMap[current],
        },
      },
    };
  }, {} as TranslatedFontSize);
};

export const createTypographySizesFontFamiliesMap = (fontSizeMap: FontSizeMap) => {
  return (Object.keys(fontSizeMap) as TypographySize[]).reduce((sizesObj: TypographySizesFontFamiliesMap, current) => {
    return {
      ...sizesObj,
      [current]: {
        fontFamily: fontSizeMap[current].fontFamily,
        defaultFontFamily: fontSizeMap[current].defaultFontFamily,
      },
    };
  }, {} as TypographySizesFontFamiliesMap);
};

export const defaultWebFontsContext = {
  gigantic: 'inherit',
  huge: 'inherit',
  large: 'inherit',
  bigger: 'inherit',
  big: 'inherit',
  normal: 'inherit',
};
